<div class="card">
    <div class="mb-6 rounded-3xl border border-primary-500/20 bg-white/5 p-4">

        <div class="w-full">
            <label class="mb-2 block text-sm font-semibold text-primary-500">Localita</label>
            <input [(ngModel)]="filtri.location" type="text" list="location-options" placeholder="Inserisci la localita"
                class="w-full rounded-2xl border border-primary-500/20 bg-white/10 px-4 py-3 outline-none transition-all duration-300 focus:border-primary-500" />
            <datalist id="location-options">
                @for (option of locationOptions; track option.id) {
                <option [value]="option.codice"></option>
                }
            </datalist>
        </div>
        <div class="flex flex-col gap-4 lg:flex-row lg:items-end">
        <div class="w-full">
            <label class="mb-2 block text-sm font-semibold text-primary-500">Tipo</label>
            <input [(ngModel)]="filtri.type" type="text" list="type-options" placeholder="Inserisci il tipo"
                class="w-full rounded-2xl border border-primary-500/20 bg-white/10 px-4 py-3 outline-none transition-all duration-300 focus:border-primary-500" />
            <datalist id="type-options">
                @for (option of typeOptions; track option.id) {
                <option [value]="option.codice"></option>
                }
            </datalist>
        </div>

        <div class="w-full">
            <label class="mb-2 block text-sm font-semibold text-primary-500">POI</label>
            <input [(ngModel)]="filtri.poi" type="text" list="poi-options" placeholder="Inserisci il POI selezionato"
                class="w-full rounded-2xl border border-primary-500/20 bg-white/10 px-4 py-3 outline-none transition-all duration-300 focus:border-primary-500" />
            <datalist id="poi-options">
                @for (option of poiOptions; track option.id) {
                <option [value]="option.codice"></option>
                }
            </datalist>
        </div>

        <div class="flex w-full gap-2 lg:w-auto">
            <button type="button"
                class="w-full rounded-full bg-primary-500 px-5 py-3 font-semibold text-black transition-all duration-300 hover:opacity-90 lg:w-auto"
                [disabled]="ricercaInCorso" (click)="search()">
                Avvia ricerca
            </button>

            <button type="button"
                class="w-full rounded-full border border-primary-500/30 px-5 py-3 font-semibold transition-all duration-300 hover:bg-white/5 lg:w-auto"
                [disabled]="ricercaInCorso" (click)="resetFilters()">
                Reset
            </button>
        </div>
    </div>
</div>

<div class="grid grid-cols-4 gap-4">
    <div class="col-span-4 flex justify-center items-center">
        <button mat-icon-button (click)="add()">
            <mat-icon>add</mat-icon>
        </button>

    </div>
    @for(missione of missioni; track $index){

    <div class="shadow-small flex flex-col rounded-3xl hover:scale-105 transition-spring-500ms hover:cursor-pointer">
        <div (click)="edit(missione.id)" class="flex flex-col gap-2 p-4 hover:cursor-pointer">
            <p class="font-bold text-2xl text-primary-500">
                {{missione.name}}
            </p>

            <p class="w-full text-sm font-light">{{missione.description}}</p>
            <app-card-summary-singleline title="Localita"
                [value]="missione.missionLocation?.name ?? missione.missionLocationName ?? '-'"></app-card-summary-singleline>
            <app-card-summary-singleline title="Punti"
                [value]="missione.pointsRedeem ? missione.pointsRedeem.toString() : '0'"></app-card-summary-singleline>
            <app-card-summary-singleline title="Cuori"
                [value]="missione.hearts.toString()"></app-card-summary-singleline>
            <app-card-summary-singleline title="Tipo sblocco"
                [value]="unlockTypeToString(missione.unlockType)"></app-card-summary-singleline>
            <app-card-summary-singleline title="Step"
                [value]="missione.steps ? missione.steps.length.toString() : '0'"></app-card-summary-singleline>
        </div>

        <div class="flex justify-end items-center p-2">
            <button mat-icon-button style="color:red!important" [matMenuTriggerFor]="menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 7l16 0" />
                    <path d="M10 11l0 6" />
                    <path d="M14 11l0 6" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
            </button>

            <mat-menu #menu="matMenu" backdropClass="bg-black/20">
                <div class="rounded-3xl bg-primary-950 p-4 flex flex-col gap-4">
                    <p class="text-primary-400">Vuoi procedere con l'eliminazione?</p>
                    <div class="flex justify-center items-center gap-2">
                        <button type="button" class="w-full bg-primary-500 text-black p-2 rounded-full">Annulla</button>
                        <button type="button" class="w-full bg-red-500 text-white p-2 rounded-full"
                            (click)="delete(missione.id)">Elimina</button>
                    </div>
                </div>

            </mat-menu>
        </div>

    </div>
    }

    @if(missioni.length == 0){
    <div class="col-span-4 flex justify-center items-center">
        <p>{{ ricercaInCorso ? 'Ricerca in corso...' : 'Nessuna missione trovata' }}</p>
    </div>
    }
</div>
</div>
